import { queryOptions, useQuery } from "@tanstack/react-query";
import { useAuth } from "@/core/hooks/useAuth";
import { fetchAccountAccesses } from "@/core/api/userApi";
import { baseQueryOptions } from "@/core/hooks/useApiQueries/baseQueryOptions";
import { BFFAccountAccessSummary } from "@/types";

/** Os acessos do usuário, para o hook e para o boot (SA-1452). */
export const accountAccessesQueryOptions = (token: string | undefined) =>
  queryOptions({
    queryKey: ["user", "account-accesses"],
    queryFn: (): Promise<BFFAccountAccessSummary[]> =>
      fetchAccountAccesses({ token }),
    ...baseQueryOptions,
    // A perda de acesso chega por três caminhos (o useAccessLossWatcher percebe):
    // `account_access_updated` no socket, o interceptor de 403 do axios (qualquer
    // request do setor) e voltar para a aba com a lista velha (staleTime). Setor
    // sem WhatsApp não tem socket, então ali vale só o 403 e o foco. Sem polling
    // (SA-1449): o intervalo de 60 s fazia ~20x as requests de antes (uma por
    // minuto em cada aba visível, 19 queries cada).
    refetchOnWindowFocus: true,
  });

export const useAccountAccesses = () => {
  const { isLoggedIn, token } = useAuth();

  return useQuery({
    ...accountAccessesQueryOptions(token),
    enabled: isLoggedIn && !!token,
  });
};
